import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./library.css";

export default function AddBook() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [saving,     setSaving]     = useState(false);
  const [form, setForm] = useState({
    title: "", author: "", categoryId: "",
    isbn: "", description: "", totalCopies: 1,
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const loadCategories = async () => {
    try {
      const res = await API.get("/school-admin/library/categories/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setCategories(res.data.categories || []);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadCategories(); }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return alert("Book title is required");
    if (!form.totalCopies || form.totalCopies < 1) return alert("Total copies must be at least 1");
    try {
      setSaving(true);
      await API.post(
        "/school-admin/library/books/",
        {
          title:        form.title.trim(),
          author:       form.author.trim() || null,
          category:     form.categoryId || null,
          isbn:         form.isbn.trim() || null,
          description:  form.description.trim() || null,
          total_copies: form.totalCopies,
        },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      navigate("/school-admin/library/books");
    } catch (err) { console.error(err); alert("Failed to add book"); }
    finally { setSaving(false); }
  };

  return (
    <div className="lb-page">

      {/* ══ HERO ══ */}
      <div className="lb-hero">
        <div className="lb-hero-left">
          <div className="lb-hero-icon">📗</div>
          <div>
            <h2 className="lb-hero-title">Add Book</h2>
            <p className="lb-hero-sub">Add a new book to the library catalog</p>
          </div>
        </div>
        <div className="lb-hero-right">
          <button className="lb-btn-back" onClick={() => navigate("/school-admin/library/books")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSave}>
        <div className="lb-form-card">
          <p className="lb-form-title">Book Details</p>

          <div className="lb-grid-2">
            <div className="lb-field">
              <label>Book Title *</label>
              <input required placeholder="e.g. Mathematics Part II" value={form.title} onChange={e => set("title", e.target.value)} />
            </div>
            <div className="lb-field">
              <label>Author</label>
              <input placeholder="Author name (optional)" value={form.author} onChange={e => set("author", e.target.value)} />
            </div>
            <div className="lb-field">
              <label>Category</label>
              <select value={form.categoryId} onChange={e => set("categoryId", e.target.value)}>
                <option value="">— Select Category —</option>
                {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="lb-field">
              <label>ISBN</label>
              <input placeholder="ISBN (optional)" value={form.isbn} onChange={e => set("isbn", e.target.value)} />
            </div>
            <div className="lb-field">
              <label>Total Copies</label>
              <input
                type="number" min="1"
                value={form.totalCopies}
                onChange={e => set("totalCopies", Math.max(1, parseInt(e.target.value || "1", 10)))}
              />
            </div>
            <div className="lb-field lb-field-full">
              <label>Description</label>
              <textarea placeholder="Brief description (optional)" value={form.description} onChange={e => set("description", e.target.value)} />
            </div>
          </div>

          <button type="submit" className="lb-btn-submit" disabled={saving}>
            {saving ? <><div className="lb-spinner"></div> Saving…</> : "✓ Save Book"}
          </button>
        </div>
      </form>

    </div>
  );
}
